<template>
  <a-card v-if="getScreen">
    <span slot="title">UM PD Report Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Usage" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
        <a-button
          v-if="current == steps.length - 1"
          type="default"
          :loading="btnLoading"
          @click="saveMobile"
          :disabled="dataList.length <= 1"
        >{{ status === false ? "Save Draft" : "Save" }}</a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
  <a-row :gutter="8" v-else>
    <loading v-if="pageLoading" />
    <a-col :span="leftcolumn" class="m-page-wrapper">
      <a-card :loading="loading" class="m-height-full m-display-flex flex-column">
        <span slot="title">
          <a-tag slot="extra">{{ mode }}</a-tag>UM PD Report Form
        </span>
        <a-steps :current="current" status="process">
          <a-step title="Information" />
          <a-step title="Usage" />
          <a-step title="Approval" />
        </a-steps>
        <div class="steps-content flex-1">
          <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button-group>
              <a-button v-if="current == 1" type="primary" @click="handleNew" :loading="loadingAdd">Add</a-button>
              <a-button v-if="current < steps.length - 1" type="default" @click="next">Next</a-button>
              <a-button
                v-if="type !== 'revised' && (current == (steps.length - 1))"
                type="default"
                @click="saveDraft"
                :disabled="disableSaveButton"
              >Save Draft</a-button>
              <a-button
                v-if="current == (steps.length - 1)"
                type="primary"
                :loading="btnLoading"
                @click="save"
                :disabled="disableSaveButton"
              >Save</a-button>
            </a-button-group>
            <a-button v-if="current > 0" @click="prev">Previous</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <a-col :span="rightcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex flex-column">
        <div slot="title">
          <span>Reporting Details</span>
        </div>
        <template slot="extra">
          <a-button :loading="collectiveLoading" @click="onCollective" class="margin-right-small" icon="edit">Collective</a-button>
          <a-button @click="handleExpand()">
            <span>{{labelExpand}}</span>
          </a-button>
        </template>
        <a-table
          :rowKey="(record, index) => {return index;}"
          :columns="columns"
          :dataSource="reportingCalc"
          :pagination="pagination"
          size="small"
          class="flex-1"
          :scroll="{ x: 750 }"
          :loading="loadingTable"
          bordered
        >
          <template slot="operation" slot-scope="index, item">
            <a-button-group v-if="item.edit_hapus ? item.edit_hapus!='0' : item.kredit">
              <a-button
                type="primary"
                :loading="loadingBtnEdit && idlistEdit==item.id"
                @click="handleEdit(item)"
              >
                <a-icon type="edit" />
              </a-button>
              <a-button type="danger" @click="handleRemoveDetail(item)">
                <a-icon type="close" />
              </a-button>
            </a-button-group>
          </template>
          <template slot="no" slot-scope="record, item, index">
            <span>{{ (pagination.page - 1) * pagination.pageSize + index + 1 }}</span>
          </template>
          <template slot="debit" slot-scope="record, item, index">
            <span>
              {{
              item.debit == "" ? "-" : formatCurrency(mata_uang, item.debit)
              }}
            </span>
          </template>
          <template slot="kredit" slot-scope="record, item, index">
            <span>{{ formatCurrency(mata_uang, item.kredit) }}</span>
          </template>
          <template slot="balance" slot-scope="record, item, index">
            <span>{{ item.sisa }}</span>
          </template>
          <template slot="deskripsi" slot-scope="index, item">
            <h4 class="margin-remove">{{ item.item_um }}</h4>
            <small>
              {{
              item.kode_anggaran
              ? item.kode_anggaran + " | " + item.deskripsi
              : item.deskripsi
              }}
            </small>
            <a-alert
              type="error"
              banner
              v-if="item.edit_hapus ? item.edit_hapus!='0' : (item.kredit!='' &&(item.kode_anggaran == null 
                || item.kode_anggaran == ''))"
              message="item anggaran cannot be empty"
            />
          </template>
          <template slot="commission" slot-scope="index, item">
            <span v-if="item.iscommision=='1'">
              Yes
            </span>
            <span v-else>
              No
            </span>
          </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="tanggal" slot-scope="index, item">
            <span>
              {{
              moment(item.tanggal_pemakaian, getStandartFormatDate).format(
              getDefaultDateFormat
              )
              }}
            </span>
          </template>
        </a-table>
        <div class="m-price-total" v-if="loading === false && debit">
          <div class="m-display-flex space-between align-middle">
            <h4>Debit</h4>
            <h3>{{ formatCurrency(mata_uang, debit) }}</h3>
          </div>
          <div class="m-display-flex space-between align-middle">
            <h4>Credit</h4>
            <h3>{{ formatCurrency(mata_uang, kredit) }}</h3>
          </div>
          <a-divider class="margin-small"></a-divider>
          <div class="m-display-flex space-between align-middle">
            <h4>Remaining Balance</h4>
            <h3>{{ formatCurrency(mata_uang, sisa_saldo) }}</h3>
          </div>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div
            class="steps-action"
            v-if="
                current == steps.length - 1 ||
                  (mode === 'Edit' && type !== 'draft')
              "
          >
            <a-button
              v-if="current == steps.length - 1"
              type="primary"
              :loading="btnLoading"
              @click="save"
              :disabled="disableSaveButton"
            >Save</a-button>
            <a-button
              type="default"
              @click="saveDraft"
              :disabled="disableSaveButton"
              v-if="(current == steps.length - 1) && type !== 'revised'"
            >Save Draft</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <Modal :data="modal.data" :modalEdit="modal.modalEdit" :confirmLoading="modal.confirmLoading" />
    <Collective v-if="isCollective" :close="handleCloseCollective">
      <div slot="title">
        <a-icon type="edit" />&nbsp;Edit Collective
      </div>
      <template slot="content">
        <a-form class="margin-bottom" :form="formCollective">
          <a-form-item label="UM Detail">
            <a-select
              showSearch
              placeholder="UM Detail"
              class="select-between"
              v-decorator="[
              'um_detail',
              { rules: [{ required: true }]},
            ]"
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="handleChangeumDtl"
            >
              <a-select-option v-for="item in list" :key="item.id_um_dtl">
                <div class="select-option">
                  <div v-if="!getScreen">
                    <h4>{{ item.item_nm }}</h4>
                  </div>
                  <h4 v-else>{{ item.item_nm }}</h4>
                  <small>
                    {{
                    formatRupiah(item.saldo_um)
                    .replace("Rp", "")
                    .replace(",00", "")
                    }}
                  </small>
                </div>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-table
          :rowKey="(record, index) => {return index;}"
          :columns="columns"
          :dataSource="reportingCalc"
          :pagination="pagination_rptdtl"
          size="small"
          class="flex-1"
          :scroll="{ x: 750 }"
          :loading="loadingTable"
          bordered
        >
          <template slot="customTitle">
            {{this.isCollective ? "Check" : "Action"}}&nbsp;
            <a-checkbox v-model="checkAllCollective" @change="onCheckAllChange">
            </a-checkbox>
          </template>
          <template slot="title" slot-scope="currentPageData">
            <div class="search-wrapper" style="text-align:right">
              <a-input-search
                v-model="searchCollective"
                @change="onSearchCollective"
                placeholder="Search... "
                :style="getScreen ? 'width:100%' : 'width:30%'"
                :loading="timer.loadingcollective"
              >
              </a-input-search>
            </div>
          </template>
          <template slot="operation" slot-scope="index, item">
            <a-checkbox
              v-if="item.edit_hapus ? item.edit_hapus!='0' : item.kredit"
              :checked="selected.filter(obj => obj.id == item.id).length == 0 ? false : true"
              @change="handleCheck"
              :value="item"
            />
          </template>
          <template slot="no" slot-scope="record, item, index">
            <span>{{ (pagination_rptdtl.page - 1) * pagination_rptdtl.pageSize + index + 1 }}</span>
          </template>
          <template slot="debit" slot-scope="record, item, index">
            <span>
              {{
              item.debit == "" ? "-" : formatCurrency(mata_uang, item.debit)
              }}
            </span>
          </template>
          <template slot="kredit" slot-scope="record, item, index">
            <span>{{ formatCurrency(mata_uang, item.kredit) }}</span>
          </template>
          <template slot="balance" slot-scope="record, item, index">
            <span>{{ item.sisa }}</span>
          </template>
          <template slot="deskripsi" slot-scope="index, item">
            <h4 class="margin-remove">{{ item.item_um }}</h4>
            <small>
              {{
              item.kode_anggaran
              ? item.kode_anggaran + " | " + item.deskripsi
              : item.deskripsi
              }}
            </small>
            <a-alert
              type="error"
              banner
              v-if="item.edit_hapus ? item.edit_hapus!='0' : (item.kredit!='' &&(item.kode_anggaran == null 
                || item.kode_anggaran == ''))"
              message="item anggaran cannot be empty"
            />
          </template>
          <template slot="commission" slot-scope="index, item">
            <span v-if="item.iscommision=='1'">
              Yes
            </span>
            <span v-else>
              No
            </span>
          </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="tanggal" slot-scope="index, item">
            <span>
              {{
              moment(item.tanggal_pemakaian, getStandartFormatDate).format(
              getDefaultDateFormat
              )
              }}
            </span>
          </template>
        </a-table>
      </template>
      <a-button-group slot="action">
        <a-button @click="handleSet" type="primary" :disabled="selected.length == 0">Set</a-button>
        <a-button @click="handleCloseCollective" :type="selected.length == 0 ? 'primary' : ''">Done</a-button>
      </a-button-group>
    </Collective>
  </a-row>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Informasi from "./steps/InformasiLaporanUmpd.vue";
import Pemakaian from "./steps/PemakaianLaporanUmpd.vue";
import Approval from "./steps/Persetujuan.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import loading from "@/components/preloader/Loading.vue";
import nanoid from "nanoid";
import Modal from "./Modal.vue";
import moment from "moment";
import Collective from "@/components/collective/Collective.vue";
import collectiveLapPD from "@/mixins/collective/collectiveLapPD";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "CreateLaporanUmpd",
  props: ["id", "type"],
  components: {
    Informasi,
    Pemakaian,
    Approval,
    Modal,
    loading,
    Collective,
  },
  mixins: [CurrencyFormat, collectiveLapPD, GlobalMethod],
  data() {
    return {
      loading: true,
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Pemakaian",
          content: "Pemakaian",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData: {},
      mode: "Create",
      id_lk: "",
      id_um: "",
      active: false,
      status: false,
      dataList: [],
      url: "",
      debit: 0,
      kredit: 0,
      mata_uang: "",
      sisa_saldo: 0,
      pageLoading: true,
      pagination: {
        onChange: (page) => {
          this.pagination.page = page; 
        },
        page: 1,
        pageSize: 5,
        size: "small",
      },
      pagination_rptdtl: {
        onChange: (page) => { 
          this.pagination_rptdtl.page = page; 
        },
        page: 1,
        pageSize: 5,
        size: "small",
      },
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: 0,
          id: "",
          debit: 0,
        },
      },
      btnLoading: false,
      loadingTable: false,
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingBtnEdit: false,
      idlistEdit: undefined,
      loadingAdd: false,
      EnCommission: false,
      Viwithout_note: true,
      searchCollective:'',
      checkAllCollective: false,
      timer: {
        collective: null,
        loadingcollective: false,
      }
    };
  },
  async created() {
    this.id_lk = nanoid(11);
    if (this.id) {
      this.mode = "Edit";
      if (this.type === "draft") {
        this.url = this.$serviceUrl + "lap_um_pd/detil_pemakaian";
        await this.fetchEdit(this.url);
      } else {
        this.url = this.$serviceUrl + "lap_um_pd/revisi_detil_pemakaian";
        await this.fetchEdit(this.url);
        this.status = true;
        this.type = "revised";
      }

      await this.fetchPemakaian();
      this.pageLoading = false;
      this.loading = false;
    }

    if (this.mode == "Create") {
      
      await this.$store
        .dispatch("getFetchLapUmpd", { auth: this.getAuth })
        .then((res) => {
          this.url = this.$serviceUrl + "lap_um_pd/detil_pemakaian";
          this.pageLoading = false;
          this.loading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            if (this.mode === "Create") {
              this.displayMessageValue(
                "error-nothave-umpd",
                err.response.data.message
              );
              this.$router.go(-1);
            } else {
              this.pageLoading = false;
              this.loading = false;
            }
          }
        });
    }
  },
  mounted(){
    console.log("mounted", this.mode)
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    stepProps() {
      let step = {};
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          step = {
            data: this.collectData.informasi,
            others: this.collectData.others,
            mode: this.mode,
            type: this.type,
            active: this.active,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          step = {
            data: this.collectData.pemakaian,
            informasi: this.collectData.informasi,
            id_lk: this.collectData.others.id_lk,
            mode: this.mode,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            url: this.url,
            type: this.type,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          step = {
            data: this.collectData.informasi,
            others: this.collectData.others,
            mode: this.mode,
            active: this.active,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          step = {
            data: this.collectData.pemakaian,
            informasi: this.collectData.informasi,
            id_lk: this.id_lk,
            mode: this.mode,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            url: this.url,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      }

      return step;
    },
    stepRef() {
      let ref = "";
      if (this.steps[this.current].content === "Informasi") {
        ref = "refInformasi";
      } else if (this.steps[this.current].content === "Pemakaian") {
        ref = "refPemakaian";
      } else {
        ref = "refApproval";
      }
      return ref;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          align: "center",
          scopedSlots: { customRender: "no" },
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Date",
          dataIndex: "tanggal",
          width: 110,
          key: "tanggal",
          scopedSlots: { customRender: "tanggal" },
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Description",
          dataIndex: "deskripsi",
          key: "deskripsi",
          scopedSlots: { customRender: "deskripsi" },
          width: 300,
          sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 125,
          align: "center"
        },
        {
          title: "Commission",
          key: "commission",
          scopedSlots: { customRender: "commission" },
          width: 125,
          align: "center"
        },
        {
          title: "Debit",
          dataIndex: "debit_value",
          key: "debit_value",
          width: 200,
          scopedSlots: { customRender: "debit" },
          align: "right",
          sorter: (a, b) => a.debit.length - b.debit.length,
        },
        {
          title: "Credit",
          dataIndex: "kredit_value",
          key: "kredit_value",
          scopedSlots: { customRender: "kredit" },
          width: 200,
          align: "right",
          sorter: (a, b) => a.kredit.length - b.kredit.length,
        },
        {
          title: "Balance",
          dataIndex: "sisa",
          scopedSlots: { customRender: "balance" },
          key: "sisa",
          width: 200,
          align: "right",
          sorter: (a, b) => a.sisa.length - b.sisa.length,
        },
        {
          slots: { title: 'customTitle' },
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: this.isCollective ? 90 : 110,
          align: "center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    reportingCalc() {
      let data = this.searchCollective ? 
        _.filter(this.dataList, (e) =>  
          (e.deskripsi && e.deskripsi.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.tanggal && e.tanggal.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) )
        : this.dataList
      //console.log(data)
      let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          if (value.kredit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.kredit
            );
            debit = debit - value.kredit;
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
          data[index]["iscommision"] = value.iscommision;
          data[index]["without_note"] = value.without_note;
        });
      }
      return data;
    },
    disableSaveButton() {
      let result = this.labelExpand == "Collapse";
      if (result) {
        result = true;
      } else {
        result = this.dataList.length < 1;
      }
      return result;
    },
  },
  methods: {
    moment,
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
        if (this.mode == "Edit" && this.getScreen) {
          Event.$emit("fetchDetilUm", true);
          Event.$emit("fetchPemakaian");
          //this.$refs.refPemakaian.fetchUmList();
          // this.$refs.refPemakaian.form.resetFields();
        }
      } else if (this.steps[this.current].content === "Pemakaian") {
        //this.$refs.refPemakaian.handleRef();
        if(this.dataList.length<=1){
           this.displayMessageValue(
              "error-other",
              "Data Details can't be empty, because this transaction has at least 1 data!"
            );
        }else{
          let exceedDate = _.filter(this.dataList, item => moment(item.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD'))
          if(exceedDate.length>0){
            this.displayMessageValue("error-other", "Usage date can't exceed today!");
            return;
          }
          this.getApproval();
        }
      }
    },
    prev() {
      if(this.steps[this.current].content === "Approval"){
        this.$refs.refApproval.handleRef();
        this.expandcolumn("collapse");
      }
      this.current--;
    },
    saveMobile() {
      this.$refs.refApproval.handleRef();
      if (this.status) {
        this.save();
      } else {
        this.saveDraft();
      }
    },
    save() {
      this.$refs.refApproval.handleRef();
      if (!this.getScreen) {
        this.status = true;
      }
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    saveDraft() {
      this.$refs.refApproval.handleRef();
      if (!this.getScreen) {
        this.status = false;
      }
      this.confirmMessage("confirm-draft");
    },
    doDraft() {
      this.$store
          .dispatch("savedraftparsial", {
            auth: this.getAuth,
            condition: {
              method: 'post',
              data: {
                id_lk : this.id,
                isparsial : this.collectData.informasi.isparsial,
                catatan : this.collectData.informasi.catatan,
              }
            },
          })
          .then((res) => {
            this.$router.push({ name: "laporanUmpd" });
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            if (responses.status == false) {
              this.displayMessageValue("error-other", responses.message);
            } else {
              this.displayMessageValue("error", responses);
            }
            this.btnLoading = false;
          })
    },
    validate() {
      this.$refs.refApproval.handleRef();
      if (this.status) {
        let condition = {};
        this.btnLoading = true;
        if (this.type == "revised") {
          condition.method = "put";
          condition.data = {
            tlc: this.getAuth.username,
            id_lk: this.id,
            no_um: this.collectData.informasi.no_um,
            tanggal_pelaporan: moment(
              this.collectData.informasi.tanggal_pelaporan
            ).format(this.getStandartFormatDate),
            public_manifest_url:
              "/pu/lapmanifestumpd/" + this.collectData.others.id_lk,
            isparsial: this.collectData.informasi.isparsial,
            catatan : this.collectData.informasi.catatan ? 
              this.collectData.informasi.catatan : '',
          };
        } else {
          condition.method = "post";
          condition.data = {
            tlc: this.getAuth.username,
            id_lk:
              this.mode == "Edit" ? this.collectData.others.id_lk : this.id_lk,
            no_um: this.collectData.informasi.no_um,
            tanggal_pelaporan: moment(
              this.collectData.informasi.tanggal_pelaporan
            ).format(this.getStandartFormatDate),
            public_manifest_url: "/pu/lapmanifestumpd/" + this.id_lk,
            isparsial: this.collectData.informasi.isparsial,
            catatan : this.collectData.informasi.catatan ? 
              this.collectData.informasi.catatan : '',
          };
        }

        this.$store
          .dispatch("saveLapUmpd", {
            auth: this.getAuth,
            condition: condition,
          })
          .then((res) => {
            this.displayMessage("success-save");
            this.btnLoading = false;
            this.$router.push({ name: "laporanUmpd" });
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            if (responses.status == false) {
              this.displayMessageValue("error-other", responses.message);
            } else {
              this.displayMessageValue("error", responses);
            }
            this.btnLoading = false;
          });
      } else {
        this.$router.push({ name: "laporanUmpd" });
      }
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value;
        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        this.collectData.persetujuan = JSON.parse(
          JSON.stringify(value.persetujuan)
        );
        //this.submit();
      } else if (this.steps[this.current].content === "Approval"){
        this.collectData.informasi.catatan = value.note;
      }
    },

    fetchDetilUm() {
      let params = {};
      if (this.mode == "Create") {
        params = {
          id_lk: this.collectData.informasi.no_um,
          mode: this.mode,
        };
      } else {
        params = {
          id_lk: this.id,
          mode: this.mode,
        };
      }

      let url =
        this.type == "revised"
          ? "lap_um_pd/revisi_detil_pemakaian"
          : "lap_um_pd/detil_pemakaian";

      this.$store
        .dispatch("getDetilLapUm", { auth: this.getAuth, params: params, url })
        .then((res) => {
          if (this.current == 1) {
            this.$refs.refPemakaian.fetchUmList();
          }
          this.dataList = res.detail_pemakaian;
          this.kredit = res.total_kredit;
          this.sisa_saldo = res.sisa_saldo;
        });
    },

    // Terlalu belibet
    fetchEdit(url) {
      axios({
        method: "get",
        url: url,
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            detil_pemakaian: response.data.detail_pemakaian,
            informasi: {
              no_um: response.data.no_um,
              tanggal_pelaporan: response.data.tgl_buat,
              bod: response.data.bod + " - " + response.data.nama_bod,
              id_um: response.data.id_um,
              isparsial: response.data.isparsial,
              catatan: response.data.catatan,
            },
            others: {
              mata_uang: response.data.mata_uang,
              id_lk: response.data.id_lk,
              peruntukan: response.data.peruntukan,
              sisa_saldo: response.data.sisa_saldo,
              total_debit: response.data.total_debit,
              total_kredit: response.data.total_kredit,
              assignee: response.data.assignee
            },
          };
          this.loading = false;
        })
        .catch((err) => {
          this.displayMessage("error-getdetil");
          // this.$router.go(-1);
        });
    },
    fetchPemakaian() {
      let id_lk = "";
      this.loadingAdd = true;
      if (this.mode == "Edit") {
        id_lk = this.id;
      } else if (this.mode === "Create") {
        id_lk = this.collectData.informasi.no_um;
      }

      this.loadingTable = true;

      if (!this.getScreen) {
        axios({
          method: "get",
          url: this.url,
          params: {
            tlc: this.getAuth.username,
            id_lk: id_lk,
            mode: this.mode,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataList = response.data.detail_pemakaian;
            this.debit = response.data.total_debit;
            this.kredit = response.data.total_kredit;
            this.sisa_saldo = response.data.sisa_saldo;
            this.mata_uang = response.data.mata_uang;
            // if (this.$refs.refPemakaian) this.$refs.refPemakaian.done();
            this.loadingTable = false;
            if (this.dataList.length === 1) {
              this.active = false;
            }
            this.loadingAdd = false;
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data.message === "Tidak Memiliki Detil Pemakaian"
            ) {
              this.active = false;
              this.mode = "Create";
              this.dataList = [];
              this.collectData = {};
              this.debit = 0;
              this.sisa_saldo = 0;
              this.kredit = 0;
              // this.$router.push({ name: 'laporanUmpd' });
            }
            this.loadingTable = false;
            this.loading = false;
            this.loadingAdd = false;
          });
      } else {
        if (this.steps[this.current].content === "Pemakaian") {
          axios({
            method: "get",
            url: this.url,
            params: {
              tlc: this.getAuth.username,
              id_lk: id_lk,
              mode: this.mode,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.dataList = response.data.detail_pemakaian;
              this.debit = response.data.total_debit;
              this.kredit = response.data.total_kredit;
              this.sisa_saldo = response.data.sisa_saldo;
              this.mata_uang = response.data.mata_uang;
              //this.$refs.refPemakaian.done();
              this.loadingTable = false;
              if (this.dataList.length === 1) {
                this.active = false;
              }
              this.loadingAdd = false;
            })
            .catch((err) => {
              let response = Object.assign({}, err.response.data);
              if (response.message === "Tidak Memiliki Detil Pemakaian") {
                this.current = 0;
                this.active = false;
                this.mode = "Create";
                this.collectData = {};
                this.$refs.refPemakaian.done();
                this.displayMessage("error");
              }
              this.loading = false;
              this.loadingTable = false;
              this.loadingAdd = false;
            });
        }
      }

      axios({
        method: "get",
        url: this.$serviceUrl + "main/limit_laporan_um",
        params: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.limitasi = response.data.limit;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    handleNew() {
      this.$refs.refPemakaian.handleNew();
    },
    handleEdit(item) {
      if (this.type == "revised") {
        //console.log(item);

        this.loadingBtnEdit = true;
        this.idlistEdit = item.id;
        this.$store
          .dispatch("getLapReviseDetilUM", {
            auth: this.getAuth,
            id: item.id,
          })
          .then((response) => {
            this.$store
              .dispatch("getLapDetilUM", {
                auth: this.getAuth,
                id: this.collectData.informasi.id_um,
              })
              .then((res) => {

                this.modal.data = {
                  list_um: res.list_nama_item,
                  tanggal_pemakaian: response.tgl,
                  deskripsi: response.detail,
                  kredit: response.kredit,
                  selected_um: response.selected_um_dtl,
                  id: item.id,
                  type: this.id
                    ? this.type === "draft"
                      ? "edit"
                      : "revised"
                    : "edit",
                  mata_uang: this.mata_uang,
                  iscommision: item.iscommision ? item.iscommision : "0",
                  without_note: item.without_note ? item.without_note : "1",
                };

                if (!item.iscommision){
                  // this.modal.data.EnCommission=false;
                  this.modal.data.Viwithout_note=true;
                }else if(item.iscommision=="1" && response.iscommision_ori){
                  // this.modal.data.EnCommission=true;
                  this.modal.data.Viwithout_note=false;
                }else if(item.iscommision=="1" && !response.iscommision_ori){
                  // this.modal.data.EnCommission=false;
                  this.modal.data.Viwithout_note=false;
                }else{
                  this.modal.data.iscommision=="0";
                  // this.modal.data.EnCommission=false;
                  this.modal.data.Viwithout_note=true;
                }

                if (response.lampiran) {
                  let typefile = this.fileTypeFromUrl(response.lampiran);
                  let file = this.dataURLtoFile(
                    typefile + response.lampiran_file,
                    response.lampiran
                  );
                  file.uid = "vc-upload-1-1";
                  file.status = "done";
                  file.url = this.$serviceUrl + response.lampiran_path;
                  this.modal.data.doctransfiles = [];
                  this.modal.data.doctransfiles.push(file);
                }

                this.modal.modalEdit = true;
                this.loadingBtnEdit = false;
                this.idlistEdit = undefined;
              })
              .catch((err) => {
                this.loadingBtnEdit = false;
                this.idlistEdit = undefined;
              });
          })
          .catch((err) => {
            this.loadingBtnEdit = false;
            this.idlistEdit = undefined;
          });
      } else {
        this.loadingBtnEdit = true;
        this.idlistEdit = item.id;
        this.$store
          .dispatch("getLapUMDetil", {
            auth: this.getAuth,
            params: { id: item.id },
          })
          .then((response) => {
            this.$store
              .dispatch("getLapDetilUM", {
                auth: this.getAuth,
                id: this.collectData.informasi.id_um,
              })
              .then((res) => {
                this.modal.data = {
                  list_um: res.list_nama_item,
                  tanggal_pemakaian: response.tgl,
                  deskripsi: response.detail,
                  kredit: response.kredit,
                  selected_um: response.selected_um_dtl,
                  id: item.id,
                  type: this.id
                    ? this.type === "draft"
                      ? "edit"
                      : "revised"
                    : "edit",
                  mata_uang: this.mata_uang,
                  iscommision: item.iscommision ? item.iscommision : "0",
                  without_note: item.without_note ? item.without_note : "1",
                };
                
                if (!item.iscommision){
                  // this.modal.data.EnCommission=false;
                  this.modal.data.Viwithout_note=true;
                }else if(item.iscommision=="1" && response.iscommision_ori){
                  // this.modal.data.EnCommission=true;
                  this.modal.data.Viwithout_note=false;
                }else if(item.iscommision=="1" && !response.iscommision_ori){
                  // this.modal.data.EnCommission=false;
                  this.modal.data.Viwithout_note=false;
                }else{
                  this.modal.data.iscommision=="0";
                  // this.modal.data.EnCommission=false;
                  this.modal.data.Viwithout_note=true;
                }

                if (response.lampiran) {
                  let typefile = this.fileTypeFromUrl(response.lampiran);
                  let file = this.dataURLtoFile(
                    typefile + response.lampiran_file,
                    response.lampiran
                  );
                  file.uid = "vc-upload-1-1";
                  file.status = "done";
                  file.url = this.$serviceUrl + response.lampiran_path;
                  
                  this.modal.data.doctransfiles = [];
                  this.modal.data.doctransfiles.push(file);
                }

                this.modal.modalEdit = true;
                this.loadingBtnEdit = false;
                this.idlistEdit = undefined;
              })
              .catch((err) => {
                this.loadingBtnEdit = false;
                this.idlistEdit = undefined;
              });
          })
          .catch((err) => {
            this.loadingBtnEdit = false;
            this.idlistEdit = undefined;
          });
      }
    },
    handleCancel(e) {
      this.modal.modalEdit = false;
    },
    handleRemoveDetail(item) {
      if (this.dataList.length > 2) {
        this.confirmMessageValue("confirm-delete", item);
      } else {
        this.displayMessageValue("delete-cancel", item);
      }
    },
    delete(item) {
      let url =
        this.type === "revised"
          ? "lap_um_pd/revisi_detil_pemakaian"
          : "lap_um_pd/detil_pemakaian";

      this.loadingTable = true;
      this.$store
        .dispatch("deleteLapDetil", {
          auth: this.getAuth,
          params: { url: url, id: item.id },
        })
        .then((res) => {
          Event.$emit("fetchPemakaian");
          if (this.dataList.length <= 2) {
            this.$refs.refInformasi.fetchUmPD();
            this.current = 0;
          }
          this.$refs.refPemakaian.fetchUmList();
          this.loadingTable = false;
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    setpageLoading(val) {
      this.pageLoading = val;
    },
    fetchPemakaian() {
      let id_lk = "";
      if (this.mode == "Edit") {
        id_lk = this.id;
      } else if (this.mode === "Create") {
        id_lk = this.collectData.informasi.no_um;
      }

      if (!this.getScreen) {
        axios({
          method: "get",
          url: this.url,
          params: {
            tlc: this.getAuth.username,
            id_lk: id_lk,
            mode: this.mode,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataList = response.data.detail_pemakaian;
            this.debit = response.data.total_debit;
            this.kredit = response.data.total_kredit;
            this.sisa_saldo = response.data.sisa_saldo;
            this.mata_uang = response.data.mata_uang;
            if (this.$refs.refPemakaian) this.$refs.refPemakaian.done();
            if (this.dataList.length === 1) {
              this.active = false;
            }
          })
          .catch((err) => {
            if (
              err.response.data.message === "Tidak Memiliki Detil Pemakaian"
            ) {
              this.active = false;
              this.mode = "Create";
              this.dataList = [];
              this.collectData = {};
              this.debit = 0;
              this.sisa_saldo = 0;
              this.kredit = 0;
              // this.$router.push({ name: 'laporanUmpd' });
            }
            this.$refs.refPemakaian.done();
            this.loading = false;
          });
      } else {
        if (this.steps[this.current].content === "Pemakaian") {
          axios({
            method: "get",
            url: this.url,
            params: {
              tlc: this.getAuth.username,
              id_lk: id_lk,
              mode: this.mode,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.dataList = response.data.detail_pemakaian;
              this.debit = response.data.total_debit;
              this.kredit = response.data.total_kredit;
              this.sisa_saldo = response.data.sisa_saldo;
              this.mata_uang = response.data.mata_uang;
              this.$refs.refPemakaian.done();
              if (this.dataList.length === 1) {
                this.active = false;
              }
            })
            .catch((err) => {
              let response = Object.assign({}, err.response.data);
              if (response.message === "Tidak Memiliki Detil Pemakaian") {
                this.current = 0;
                this.active = false;
                this.mode = "Create";
                this.collectData = {};
                this.$refs.refPemakaian.done();
                this.displayMessage("error");
              }
              this.loading = false;
            });
        }
      }

      axios({
        method: "get",
        url: this.$serviceUrl + "main/limit_laporan_um",
        params: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.limitasi = response.data.limit;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          //console.log(responses);
          this.displayMessageValue("error", responses);
        });
    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        this.pagination.pageSize = 5;
      }
    },
    draftStatus(val) {
      this.status = val;
    },
    handleLoading(value) {
      this.loadingAdd = value;
    },
    async getApproval(){
      let params = {
        tlc : this.getAuth.username,
        no_um : this.collectData.informasi.no_um,
        id_lk_um : this.type=='draft' ? this.id : this.id_lk,
        is_parsial: this.collectData.informasi.isparsial,
        is_draft: this.type=='revised' ? 0 : 1,
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "lap_um_pd/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.expandcolumn("expand");
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    expandcolumn(val){
      if(val=="expand"){
          this.leftcolumn = 24;
          this.rightcolumn = 0;
      }else{
          this.leftcolumn = 12;
          this.rightcolumn = 12;
      }
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
          this.form.setFieldsValue({
              without_note: "0",
          });
        });
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    onSearchCollective(){
      if (this.timer.collective) {
        clearTimeout(this.timer.collective);
        this.timer.collective = null;
      }
        this.timer.collective = setTimeout(() => {
          this.timer.loading = true;
          this.checkAllCollective = false;
          this.timer.loading = false;
      }, 600);
    },
    onCheckAllChange(val){
      this.reportingCalc.forEach((element) => {
        if(element.edit_hapus!='0'){
          let index = _.findIndex(
            this.selected,
            (e) => {
              return e.id == element.id;
            }
          );

          if(val.target.checked){
            if(index < 0){
              this.selected.push(element)
            }
          }else{
            if(index >= 0){
              this.selected = _.filter(this.selected, (e) => e.id!=element.id)
            }
          }
        }
      })
    }
  },
  mounted() {
    Event.$on("lapUmpd", this.valueFromChild);
    Event.$on("fetchPemakaian", this.fetchPemakaian);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("removeDetail", this.handleRemoveDetail);
    Event.$on("confirmMessageReturn", this.validate);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmDraftReturn", this.doDraft);
    Event.$on("fetchDetilUm", this.fetchDetilUm);
    Event.$on("loadParentPage", this.setpageLoading);
    Event.$on("draftStatus", this.draftStatus);
    Event.$on("handleLoading", this.handleLoading);
  },
  beforeDestroy() {
    Event.$off("lapUmpd", this.valueFromChild);
    Event.$off("fetchPemakaian", this.fetchPemakaian);
    Event.$off("confirmMessageReturn", this.validate);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("fetchDetilUm", this.fetchDetilUm);
    Event.$off("loadParentPage", this.setpageLoading);
    Event.$off("draftStatus", this.draftStatus);
  },
};
</script>

<style></style>
